import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../../../../services/api.service';
import { TbApiService } from '../../../../../../services/tb-api.service';

@Component({
    selector: 'delete-leadsheet-modal',
    templateUrl: 'delete-leadsheet-modal.component.html',
  styleUrls: ['./delete-leadsheet-modal.component.scss'],
  standalone: false
})
export class DeleteLeadsheetModalComponent {
    constructor(
        public thisDialogRef: MatDialogRef<DeleteLeadsheetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public modalData: any,
        private toastr: ToastrService,
        private tbApiService: TbApiService
    ) { }

    onCloseConfirm() {
        const deleteLsObj = {
            "dellsname": [{
                "leadsheetid": this.modalData.lsId,
            }]
        }
        const deleteLsCodeObj = JSON.stringify(deleteLsObj);
      this.tbApiService.removeLeadSheetName(deleteLsCodeObj).subscribe({
        next: res => {
          if (res.status === 200 && res?.data) {
            this.thisDialogRef.close(true);
            this.toastr.success('Lead sheet deleted successfully');
            }
          if(res.status != 200 && res.errors.length > 0){
            res.errors.forEach(error => {
              this.toastr.error(error);
            })
          }
        }, error: e => {
          this.toastr.error(e.error);
        }
      });
    }

    onCloseCancel() {
        this.thisDialogRef.close(false);
    }

}
